module.exports = __webpack_public_path__ + "static/media/fast-lane.3282fb0f.jpg";